// export const CHART_URL = 'https://apiho.dsc.com.vn/fta';
export const CHART_URL = 'https://min-api.cryptocompare.com';
export const SOCKET_SERVER = 'https://dev-socket.tornomy.com'
export const SOCKET_SERVER_CHAT = 'https://dev-socket.tornomy.com/chat'

export const constUrlBase = {
  bang_gia: {
    url: '/bang-gia',
    title: 'Bảng giá chứng khoán DSC | CTCP Chứng khoán DSC',
    description: 'Bảng giá chứng khoán trực tuyến DSC, cập nhật bảng giá sàn chứng khoán Hà Nội (HNX), bảng giá chứng khoán Hồ Chí Minh (HOSE), bảng giá chứng khoán UPCOM chính xác và liên tục.'
  },
  phan_tich_thi_truong: {
    url: '/phan-tich-thi-truong',
    title: 'Phân tích thị trường chứng khoán hôm nay | CTCP Chứng khoán DSC',
    description: 'Trang phân tích thị trường chứng khoán Việt Nam và thị trường chứng khoán thế giới dựa trên xu hướng dòng tiền theo ngành, giao dịch ròng khối đầu tư, xác suất giao dịch thị trường từ đó đưa ra định giá các thị trường.'
  },
  phan_tich_co_phieu: {
    url: '/phan-tich-co-phieu',
    title: (ticker: string, companyName: string) => `Phân tích Cổ phiếu ${ticker} - ${companyName} | CTCP Chứng khoán DSC`,
    description: (ticker: string, price: string) => `Phân tích cổ phiếu ${ticker}: Giá cổ phiếu ${price} realtime, khối lượng giao dịch, phân tích và đánh giá cổ phiếu ${ticker} theo 3 tiêu chí Tăng trưởng, Giá trị, Động lượng. Từ đó đưa ra khuyến nghị giao dịch vùng MUA/BÁN cho nhà đầu tư.`
  },
  danh_muc_dau_tu: {
    url: '/danh-muc-dau-tu',
    title: 'Danh mục đầu tư | CTCP Chứng khoán DSC',
    description: 'Công cụ lọc cổ phiếu tốt nhất thị trường dựa trên 3 tiêu chí: Tăng trưởng, Giá trị, Động lượng để đưa ra khuyến nghị cổ phiếu nên đầu tư hàng ngày.'
  }
} 